/**
 * SubSkillType enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file SubSkillType.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum SubSkillType {
  FLAGTRAP      = 100,
  RECOVERTRAP   = 101,
  EXAMINETRAP   = 102,
}